import { lazyFetchSearchAnswer } from 'owa-search-answer-deeplink';
import { action } from 'satcheljs/lib/legacy';

export interface SearchAnswerRouteParameters {
    query: string;
}

export const deepLinkSearchAnswerRouteHandler = action('deepLinkSearchAnswerRouteHandler')(
    async function deepLinkSearchAnswerRouteHandler(parameters: SearchAnswerRouteParameters) {
        const { query } = parameters;

        if (query) {
            lazyFetchSearchAnswer.importAndExecute(query);
        }
    }
);
